export default "__VITE_ASSET__86d29e5a__"